import adminApi from '@/apis/admin'

export default {
  state: {
    country_codes: [],
    loading: false
  },
  mutations: {
    SET_ADMIN_COUNTRY_CODES(state, list) {
      state.country_codes = list || []
    },
    SET_ADMIN_COUNTRY_CODES_LOADING(state, loading) {
      state.loading = !!loading
    }
  },
  actions: {
    async fetchAdminCountryCodes({ commit }) {
      commit('SET_ADMIN_COUNTRY_CODES_LOADING', true)
      try {
        const resp = await adminApi.listCountryCodes()
        const body = resp.data || {}
        if (body.success) commit('SET_ADMIN_COUNTRY_CODES', body.data.country_codes || [])
        return body
      } finally {
        commit('SET_ADMIN_COUNTRY_CODES_LOADING', false)
      }
    },
    async createAdminCountryCode({ dispatch }, payload) {
      const resp = await adminApi.createCountryCode(payload)
      await dispatch('fetchAdminCountryCodes')
      return resp.data
    },
    async updateAdminCountryCode({ dispatch }, { iso2, payload }) {
      const resp = await adminApi.updateCountryCode(iso2, payload)
      await dispatch('fetchAdminCountryCodes')
      return resp.data
    },
    async deleteAdminCountryCode({ dispatch }, iso2) {
      const resp = await adminApi.deleteCountryCode(iso2)
      await dispatch('fetchAdminCountryCodes')
      return resp.data
    }
  }
}
